import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import AddInfoForm from './components/addInfoForm';
import VehicleInfoList from './components/vehicleInfoList';

const VehicleInfo = ({ vehicleInfo, setVehicleInfo }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { vehicleInfoHeading }
  } = localizedStrings;

  return (
    <div style={{ border: '1px solid #e3e3e3', padding: '1.5rem' }}>
      <Box between={3}>
        <Heading level="h4">{vehicleInfoHeading}</Heading>
        <AddInfoForm
          vehicleInfo={vehicleInfo}
          setVehicleInfo={setVehicleInfo}
        />
        {vehicleInfo.length > 0 && (
          <VehicleInfoList
            vehicleInfo={vehicleInfo}
            setVehicleInfo={setVehicleInfo}
          />
        )}
      </Box>
    </div>
  );
};

VehicleInfo.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default VehicleInfo;
